<template>
  <div>
    <header-bar>管理者様へのお知らせ</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">お知らせ</h3>
      </div>
      <div class="page-block__inner">
        <div class="news-detail-area">
          <div class="news-detail">
            <div class="news-detail__heading">
              <p class="news-detail__date"> {{ item.start_date | formatDate }}</p>
              <p class="news-detail__title">
                {{ item.title }}
              </p>
            </div>
            <div class="news-detail__body">
              <!-- eslint-disable vue/no-v-html -->
              <p
                class="news-detail__paragraph"
                v-html="item.content">
              </p>
              <!-- eslint-enable vue/no-v-html -->
            </div>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn c-btn--back"
              href="#"
              @click.prevent="onReturnClicked">
              戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'NewsDetail',
  components: { HeaderBar },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      item: {
        title: null,
        content: null,
      },
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const response = await window.axios.get(`/api/client/informations/${this.id}`)
      this.item = response.data

      // 未読カウントを再読み込み
      this.$store.dispatch('auth/check', {})
    },
    onReturnClicked() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>

</style>
